import { Readable } from './readable';
export class ReadableRpcReply extends Readable {
    constructor(client, correlationId) {
        super({ objectMode: true });
        this._currentSequence = -1;
        this._read = () => {
            //noop
        };
        this._onStreamEnded = () => {
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            this._client.off('stream', this._onStreamReplyReceived);
        };
        // eslint-disable-next-line @typescript-eslint/require-await
        this._onStreamReplyReceived = async (event) => {
            if (this._correlationId !== event.correlationId) {
                return;
            }
            switch (event.type) {
                case 'begin':
                    break;
                case 'chunk': {
                    if (event.sequence != this._currentSequence + 1) {
                        this.emit('error', new Error(`stream packet received out of order (got ${event.sequence} but was expecting ${this._currentSequence + 1})`));
                        return;
                    }
                    else {
                        this._currentSequence = event.sequence;
                        const chunks = Array.isArray(event.data) ? event.data : [event.data];
                        for (const chunk of chunks) {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                            this.push(chunk);
                        }
                    }
                    break;
                }
                case 'error':
                    this.emit('error', event.error);
                    break;
                case 'end':
                    this.push(null);
                    break;
            }
        };
        this._correlationId = correlationId;
        this._client = client;
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        client.on('stream', this._onStreamReplyReceived);
        this.once('end', this._onStreamEnded);
        this.once('error', this._onStreamEnded);
    }
}
//# sourceMappingURL=readableRpcReply.js.map